<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int, validate_not_empty} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(', ');


            width.set(+title[1].split('x')[0]);
            height.set(+title[1].split('x')[1]);

           // Слайдорс 4, 250x410, открытие влево, 4 створки(ок), цвет Ral1 Глянцевый, порог Высокий (16),
            // стекло Прозрачное, Ручка Кноб (мат. хром), Без замка и без защелки, ПВХ уплотнитель с фетром,
            // глух.остекление - 222x111, алюм. труба 1212

            // Слайдорс 4, 250x410, открытие двойное, 4 створки(ок), цвет Ral1222 Глянцевый, порог Высокий (16),
            // стекло Прозрачное, слева Ручка Кноб (мат. хром), справа Ручка Труба 450 мм (мат. хром) № 633,
            // слева Без замка и без защелки, справа Замок в пол с ключем односторонний, ПВХ уплотнитель с фетром,
            // глух.остекление - 200x100, алюм. труба 2000




 //Тип порога
            for (var element in porog) {
                    if (title[5].includes(element)) {
                    ind7 = element;
                }
                }
            for (var key in openingtype) {
                if (title[2].includes(key.toLowerCase())) {
                    ind3 = key;
                }
            }
//, цвет Ral1222 Глянцевый
            ind2 = title[4].split(' ')[1].replace('Ral',''); // "  7016  "
            for (var element of color_type) {
                if (title[4].includes(element)) {
                    ind10 = element;
                }
            }
            for (var element of openingLeftRightTwin) {
                if (title[3].includes(element)) {
                    ind12 = element;
                }
            }
            for (var element of openingCentr) {
                if (title[3].includes(element)) {
                    ind12 = element;
                }
            }

            for (var key in glass) {
                if (title[6].includes(key)) {
                    ind4 = key;
                }
            }

            for (let element in torc) {
                if (item.title.toLowerCase().includes(element.toLowerCase())) {
                    ind13 = element;
                }
            }

            if (ind3!="двойное" && ind3 != 'от-центра'){

                for (var key in mezstekolka) {
                    if (title[9].includes(key)) {
                        ind9 = key;
                    }
                }

                for (var key in handle) {
                    if (title[7].includes(key)) {
                        ind6 = key;
                    }
                }

                for (var key in zamokOtCentr) {
                    if (title[8].includes(key)) {
                        ind8 = key;
                    }
                }


                if (item.title.includes('глух.остекление'))
                {
                    widthGluh = title[11].split(' - ')[1].split('x')[0];  //
                    heightGluh = title[11].split(' - ')[1].split('x')[1]; //

                    if (item.title.includes('алюм. труба'))
                    {
                        ind11=title[12].replace('алюм. труба ','')  ;
                    }
                    else{
                        ind11 ='';

                    }
                }
            }
            else if (ind3 == 'от-центра'){

                    for (var key in mezstekolka) {
                        if (title[10].includes(key)) {
                            ind9 = key;
                        }
                    }

                    for (var key in handle) {
                        if (title[7].includes(key)) {
                            ind6 = key;
                        }
                    }


                    for (var key in zamokOtCentr) {
                        if (title[8].includes(key)) {
                            ind8 = key;
                        }
                    }

                    for (let element in magnit) {
                        if (item.title.toLowerCase().includes(element.toLowerCase())) {
                            ind14 = element;
                        }
                    }


                    if (item.title.includes('глух.остекление'))
                    {
                        widthGluh = title[12].split(' - ')[1].split('x')[0];  //
                        heightGluh = title[12].split(' - ')[1].split('x')[1]; //

                        if (item.title.includes('алюм. труба'))
                        {
                            ind11=title[13].replace('алюм. труба ','')  ;
                        }
                        else{
                            ind11 ='';

                        }
                    }
                    else{
                         widthGluh ='';
                        heightGluh ='';

                    if (item.title.includes('алюм. труба'))
                    {
                        ind11=title[12].replace('алюм. труба ','')  ;
                    }
                    else{
                        ind11 ='';

                    }
                }



            }
            else{ //двойное

                    for (var key in mezstekolka) {
                        if (title[11].includes(key)) {
                            ind9 = key;
                        }
                    }

                for (var key in handle) {
                    if (title[7].includes(key)) {
                        ind6 = key;
                    }
                }
                for (var key in handle) {
                    if (title[8].includes(key)) {
                        ind62 = key;
                    }
                }

                for (var key in zamokOtCentr) {
                    if (title[9].includes(key)) {
                        ind8 = key;
                    }
                }
                 for (var key in zamokOtCentr) {
                    if (title[10].includes(key)) {
                        ind82 = key;
                    }
                }

                if (item.title.includes('глух.остекление')){
                    widthGluh = title[12].split(' - ')[1].split('x')[0];  //
                    heightGluh = title[12].split(' - ')[1].split('x')[1]; //

                    if (item.title.includes('алюм. труба'))
                    {
                        ind11=title[14].replace('алюм. труба ','')  ;
                    }
                    else{
                        ind11 ='';

                    }
                }
                else{
                    widthGluh ='';
                    heightGluh ='';

                    if (item.title.includes('алюм. труба'))
                    {
                        ind11=title[13].replace('алюм. труба ','')  ;
                    }
                    else{
                        ind11 ='';

                    }
                }
            }
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch();
            change();
        }
    };



    const openingtype = {
        'влево': 'Влево',
        'вправо': 'Вправо',
        'двойное': 'Двойное',
        'от-центра': 'От центра',
    };
    const openingLeftRightTwin = [
        '5',
        '6',
    ];
    const openingCentr = [
        '10',
        '12',
    ];
    const color_type = [
        'Глянцевый',
         'Матовый',
         'Муар',
    ];
    const glass = {
        'Прозрачное (M1) 10мм зак.': 'Прозрачное (M1) 10мм зак.',
        'Бронза (AGC) 10мм зак.': 'Бронза (AGC) 10мм зак.',
        'Грей (AGC) 10мм зак.': 'Грей (AGC) 10мм зак.',
        'Матовое 10мм зак.': 'Матовое 10мм зак.',
        'Мультифункциональное (Neutral 67) 10мм зак.': 'Мультифункциональное (Neutral 67) 10мм зак.',
        'Просветленное (AGC) 10мм зак.': 'Просветленное (AGC) 10мм зак.',
    };
    const compactor = {
        'Чёрный': 'Чёрный',
        'Серый': 'Серый',
    };
    const handle = {
        'Ручка Кноб (мат. хром)': 'Ручка Кноб (мат. хром)',
        'Ручка Кноб (мат.черная)': 'Ручка Кноб (мат.черная)',
        'Ручка Труба 1800 мм (мат. хром) № 482 с замком': 'Ручка Труба 1800 мм (мат. хром) № 482 с замком',
        'Ручка Труба 450 мм (мат. хром) № 633': 'Ручка Труба 450 мм (мат. хром) № 633',
        'Ручка Труба 500 мм (черная) № 622': 'Ручка Труба 500 мм (черная) № 622',
        'Ручка Труба 500 мм (гл. хром) № 622': 'Ручка Труба 500 мм (гл. хром) № 622',
        //    'Ручка Труба 800 мм (мат. хром) № 633': 'Ручка Труба 800 мм (мат. хром) № 633',
        //     'Ручка Труба 900 мм (мат. хром) № 650': 'Ручка Труба 900 мм (мат. хром) № 650',
        'Ручка 670 прямая черная':'Ручка 670 прямая черная',
        'Ручка 670 прямая полированная':'Ручка 670 прямая полированная',
        'Ручка 670 прямая мат.хром':'Ручка 670 прямая мат.хром',
        'Ручка 200 Модерн черная':'Ручка 200 Модерн черная',
        'Ручка 200 Модерн полированная':'Ручка 200 Модерн полированная',
        'Ручка 490 Фиера полированная':'Ручка 490 Фиера полированная',
        'Ручка 490 Фиера черная':'Ручка 490 Фиера черная',
        'Ручка 490 Фиера мат.хром':'Ручка 490 Фиера мат.хром',
        'Ручка 490 Фиера белая':'Ручка 490 Фиера белая',
        'Ручка 490 Фиера глянец золото':'Ручка 490 Фиера глянец золото',
        'Ручка 490 Фиера бронза':'Ручка 490 Фиера бронза',
        'Ручка 490 Фиера мат. Золото':'Ручка 490 Фиера мат. Золото',
        'Ручка Эйприл 400 Хром глянец':'Ручка Эйприл 400 Хром глянец',
        'Ручка Эйприл 400 Хром':'Ручка Эйприл 400 Хром',
        'Ручка Эйприл 400 Бронза':'Ручка Эйприл 400 Бронза',
        'Ручка Эйприл 400 Черная':'Ручка Эйприл 400 Черная',
    };

    const handleImages = {
        'Ручка Кноб (мат. хром)': 'кноб-хром.jpg',
        'Ручка Кноб (мат.черная)': 'кноб-черная.jpg',
        'Ручка Труба 1800 мм (мат. хром) № 482 с замком': '1800-с-замком.jpg',
        'Ручка Труба 450 мм (мат. хром) № 633': '450-хром.jpg',
        'Ручка Труба 500 мм (черная) № 622': '500-черная.jpg',
        'Ручка Труба 500 мм (гл. хром) № 622': '500-хром.jpg', // нету
        //    'Ручка Труба 800 мм (мат. хром) № 633': '450-хром.jpg', // На позицию труба 800, ставим фото как на труба 450
        //     'Ручка Труба 900 мм (мат. хром) № 650': '900.jpg',
        'Ручка 670 прямая черная':'670-черная.jpg',
        'Ручка 670 прямая полированная':'670-полиров.jpg',
        'Ручка 670 прямая мат.хром':'670-мат-хром.jpg',
        'Ручка 200 Модерн черная':'модерн-черная.jpg',
        'Ручка 200 Модерн полированная':'модерн-полиров.jpg',
        'Ручка 490 Фиера полированная':'фиера-полиров.jpg',
        'Ручка 490 Фиера черная':'фиера-черная.jpg',
        'Ручка 490 Фиера мат.хром':'фиера-мат-хром.jpg',
        'Ручка 490 Фиера белая':'фиер-белая.jpg',
        'Ручка 490 Фиера глянец золото':'фиера-глян-золото.jpg',
        'Ручка 490 Фиера бронза':'фиера-бронза.jpg',
        'Ручка 490 Фиера мат. Золото':'фиера-мат-золото.jpg',
        'Ручка Эйприл 400 Хром глянец':'эйприл-400-глянец.jpg',
        'Ручка Эйприл 400 Хром':'эйприл-400-хром.jpg',
        'Ручка Эйприл 400 Бронза':'эйприл-400-бронза.jpg',
        'Ручка Эйприл 400 Черная':'эйприл-400-черная.jpg',
    };




    const porog = {
        'Высокий (16)': 'Высокий (16)',
    };
    const zamok = {
        'Без замка и без защелки': 'Без замка и без защелки',
        'Замок в пол с ключем двухсторонний': 'Замок в пол с ключем двухсторонний',
        'Замок в пол с ключем односторонний': 'Замок в пол с ключем односторонний',
        'Защелка в пол односторонняя': 'Защелка в пол односторонняя',
        'Защёлка мини черная': 'Защёлка мини черная',
    };

    const zamokOtCentr = {
        'Без замка и без защелки': 'Без замка и без защелки',
        'Замок в пол с ключем двухсторонний': 'Замок в пол с ключем двухсторонний',
        'Замок в пол с ключем односторонний': 'Замок в пол с ключем односторонний',
        'Замок на стекло (от центра)': 'Замок на стекло (от центра)',
        'Защелка в пол односторонняя': 'Защелка в пол односторонняя',
        'Защёлка мини черная': 'Защёлка мини черная',
    };


    const mezstekolka = {
        'ПВХ уплотнитель с фетром': 'ПВХ уплотнитель с фетром',
        'Алюминиевый с зацепом': 'Алюминиевый с зацепом',
        'Алюминиевый уплотнитель с фетром':'Алюминиевый уплотнитель с фетром',
    };

    const torc = {
        'Торцевой уплотнитель ПВХ прозрачный': 'ПВХ прозрачный',
        'Торцевой уплотнитель ПВХ черный в массе': 'ПВХ черный в массе',
    };
    const magnit = {
        'Магнитный уплотнитель ПВХ прозрачный, белый магнит': 'ПВХ прозрачный, белый магнит',
        'Магнитный уплотнитель ПВХ прозрачный, черный магнит': 'ПВХ прозрачный, черный магнит',
        'Магнитный уплотнитель ПВХ черный в массе':'ПВХ черный в массе',
    };

    const fetch = async (color = '') => {
        let result = await network.fetch_data('Слайдорс 6', '', '');
        let options = await network.fetch_ind('Слайдорс 6');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', ''),
        height = parameter('height', ''),
        heightGluh = '',
        widthGluh = '',
        ind2 = '', // цвет RAL
        ind3 = 'влево', // открытие
        ind4 = 'Прозрачное (M1) 10мм зак.', // стекло
        ind6 = 'Ручка Кноб (мат. хром)', // ручки
        ind62 = 'Ручка Кноб (мат. хром)', // ручки2
        ind7 = 'Высокий (16)', // порог
        ind8 = 'Без замка и без защелки', //
        ind82 = 'Без замка и без защелки', //
        ind9 = 'ПВХ уплотнитель с фетром', // порог
        ind10  = 'Глянцевый', // тип цвета
        ind11= '', // длинна  Труба алюминиевая
        ind12= '5', // длинна  Труба алюминиевая
        ind13= 'Торцевой уплотнитель ПВХ прозрачный', // торц
        ind14= 'Магнитный уплотнитель ПВХ прозрачный, белый магнит', // магнит
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1),
        osteklGluh = '',
        stvwid= ''
    ;

   let fetchData = fetch();

    let ruchka;
    let ruchka2;
    let title;


    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height
        ;


        if (ind3 === 'двойное') {
            title =  [
                'Слайдорс 6, ', w + 'x' + h, ', открытие ',
                ind3, ', ', ind12, ' створки(ок), цвет Ral' , ind2, ' ', ind10, ', порог ', ind7, ', стекло ', ind4, ', слева ', ind6,', справа ', ind62,
                ', слева ', ind8, ', справа ', ind82, ', ', ind9, ', ', ind13
            ].join('')

        }
        else if (ind3 == 'от-центра') {
            title =  [
                'Слайдорс 6, ', w + 'x' + h, ', открытие ',
                ind3, ', ', ind12, ' створки(ок), цвет Ral' , ind2, ' ', ind10, ', порог ', ind7, ', стекло ', ind4, ', ', ind6,
                ', слева ', ind8, ', справа ', ind82, ', ', ind9, ', ', ind13, ', ', ind14
            ].join('')

        }
        else{
            title =  [
                'Слайдорс 6, ', w + 'x' + h, ', открытие ',
                ind3, ', ', ind12, ' створки(ок), цвет Ral' , ind2, ' ', ind10, ', порог ', ind7, ', стекло ', ind4, ', ', ind6,
                ', ', ind8, ', ', ind9, ', ', ind13
            ].join('')
        }

        if (+heightGluh>0 && +widthGluh >0){
            osteklGluh =  [', глух.остекление - ' , heightGluh, 'x', widthGluh].join('')
        }
        else{
            osteklGluh = '';
        }

        if (ind11!=''){
            osteklGluh = osteklGluh+ [', алюм. труба ', ind11].join('')
        }


        if (ind6.toLowerCase().includes('кноб')) {
            ruchka = 'кноб';
        } else {
            ruchka = 'труба';
        }

        if (ind62.toLowerCase().includes('кноб')) {
            ruchka2 = 'кноб';
        } else {
            ruchka2 = 'труба';
        }


        let result = {
            type: 'слайдорс 6',
            name: 'Слайдорс 6',
            subname: title.replace('Слайдорс 6, ','') + osteklGluh,
            title: title + osteklGluh,
            params: {
                ind1: (ind3 === 'двойное' ? ind3.toLowerCase() + '-' + ind12 + '-' +  ruchka + '-' +  ruchka2 :    ind3.toLowerCase()  + '-' + ind12  + '-' + ruchka),
                ind2: 'Ral' + ind2 + ' '+ind10,
                ind3:  title.replace('Слайдорс 6, ' + w + 'x' + h + ', ',  '').replace(', цвет Ral' + ind2 + ' '+ind10, '') + osteklGluh,
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 62
        };


        stvwid = 'Ширина створки ';


        if (ind12.includes("5"))
        {
            stvwid += Math.round(w / 5) + " мм.";



        }

        if (ind12.includes("6"))
        {

            stvwid += Math.round(w / 6) + " мм.";



        }

        if (ind12.includes("10"))
        {
            stvwid += Math.round(w / 10) + " мм.";


        }
        if (ind12.includes("12"))
        {
            stvwid += Math.round(w / 12) + " мм.";


        }



        _.forEach(data.result, function(el) {
            let item = _.cloneDeep(el);
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            let kolvoStvorok = ind12;
            let typeOtkr = ind3;

            if (name.includes('порог высокий 6 полосный') && ind7=='Высокий (16)') {
                kolvo = ((w+200) / 1000).toFixed(3);
            }
            if (name.includes('порог низкий 6 полосный') && ind7=='Низкий (7)' ) {
                kolvo = ((w+200) / 1000).toFixed(3);
            }

            if (name.includes('верхний профиль')) {
                kolvo = ((w+200) / 1000).toFixed(3);
            }

            if (name.includes('п-образный боковой профиль')) {
                kolvo = ((h+200) *2 / 1000).toFixed(3);
            }

            if (name.includes('створочный профиль  (10mm) высокий') && ind7=='Высокий (16)') {
                kolvo = ((w + 500) / 1000).toFixed(3);
            }
            if (name.includes('створочный профиль  (10mm) низкий порог') && ind7=='Низкий (7)' ) {
                kolvo = ((w + 500) / 1000).toFixed(3);
            }
            if (name.includes('ролик высокий порог') && ind7=='Высокий (16)') {
                kolvo = (2 * kolvoStvorok).toFixed(3);
            }
            if (name.includes('ролик низкий порог') && ind7=='Низкий (7)') {
                kolvo = (2 * kolvoStvorok).toFixed(3);
            }

            if (name == ind6.toLowerCase()) {    //ручка
                if (typeOtkr.includes('от-центра') ) {
                    kolvo = (2).toFixed(3);
                }
                else {
                    kolvo = (1).toFixed(3);
                }
            }

            if ( ind3 == 'двойное' && name == ind62.toLowerCase()) {    //ручка

                if (ind6 == ind62) {
                    kolvo = (2).toFixed(3);
                }
                else{
                    kolvo = (1).toFixed(3);
                }

            }

            if (name.includes(ind8.toLowerCase())) { // замок
                    kolvo = (1).toFixed(3);
            }
            if ((ind3 == 'двойное' || ind3 == 'от-центра') && name.includes(ind82.toLowerCase())) { // замок
                if (ind8 == ind82) {
                    kolvo = (2).toFixed(3);
                }
                else {
                    kolvo = (1).toFixed(3);
                }
            }



            if (name.includes('заглушка створочного профиля')) {
                kolvo = (2 * kolvoStvorok).toFixed(3);
            }
            if (name.includes('щеточный уплотнитель (п-профиль)')) {
                kolvo = (4 * h / 1000).toFixed(3);
            }
            if (name.includes('щеточный уплотнитель (верхний профиль)')) {
                kolvo = (8 * w / 1000).toFixed(3);
            }
            if (ind13.toLowerCase() == name) {
                kolvo = (2).toFixed(3);
            }

            if (name.includes('магнитный уплотнитель') && ind3 == 'от-центра' && ind14.toLowerCase() == name) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('цена м2')) { // межстеколка
                  kolvo = (w * h / 1000000 + (+widthGluh) * (+heightGluh) / 1000000).toFixed(3);
            }

            if (name.includes('стекло')) {
                if (name.includes(ind4.toLowerCase()) ) {
                    kolvo = (w * h / 1000000 + (+widthGluh) * (+heightGluh) / 1000000).toFixed(3);
                }
            }

            if (name.includes('труба алюминий 100х100 длинна 3м') && +ind11 > 0 && +ind11 <= 3000 ) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('труба алюминий 100х100 длинна 6м') && +ind11  > 3000 ) {
                    kolvo = (1).toFixed(3);
            }

            if (name.includes('зажимной профиль') && +widthGluh  > 0 && +heightGluh  > 0 ) {
                kolvo = ((widthGluh * 2 + heightGluh * 2) / 1000 ).toFixed(3);
            }

            if (name.includes('алюминиевый зацеп') && ind9 == 'Алюминиевый с зацепом' ) {

                if (ind3 == 'от-центра')
                {
                    kolvo = (kolvoStvorok-2).toFixed(3);
                }
                else {
                    kolvo = (kolvoStvorok-1).toFixed(3);
                }
            }

            if (name.includes('межстекольный пвх уплотнитель')  && ind9 == 'ПВХ уплотнитель с фетром'  ) {

                if (ind3 == 'от-центра')
                {
                    kolvo = (kolvoStvorok-2).toFixed(3);
                }
                else {
                    kolvo = (kolvoStvorok-1).toFixed(3);
                }
            }

            if (name.includes('алюминиевый уплотнитель с фетром')  && ind9 == 'Алюминиевый уплотнитель с фетром'  ) {

                if (ind3 == 'от-центра')
                {
                    kolvo = (kolvoStvorok-2).toFixed(3);
                }
                else {
                    kolvo = (kolvoStvorok-1).toFixed(3);
                }
            }

            if (name.includes('щеточный уплотнитель (межстекольный)') && ind9 == 'Алюминиевый с зацепом'  ) {

                if ( ind3 == 'от-центра')
                {
                    kolvo = ((kolvoStvorok-2)*7).toFixed(3);
                }
                else {
                    kolvo = ((kolvoStvorok-1)*7).toFixed(3);
                }

            }


            // работа с ценами

            if (name.includes('цена м2') && ind10 =='Муар'  ) { // +3% к цене за квадрат при выборе Муар
                item.price  = item.price / 100 * 103;
                item.opt_price = item.opt_price / 100 * 103;
            }

            if (name.includes('цена м2') && h < 2000  ) { // Если высота меньше 2000, то добавляют 2000 к стоимости
                item.price  = +item.price + 2000;
                item.opt_price = +item.opt_price  + 2000;
            }

            if (item.ind1 === '1') {  //убираем из расчет материалы, которые входят в стоимость м.кв.

                item.price  = item.opt_price = 0;

            }



            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();
</script>


    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-12 col-sm-5">

                <div class="text-center">
                    {#if ind3== 'двойное'}
                         <img style="max-height: 250px" class="img-fluid px-3" src="/img/slaydors/открывание-{ind3.toLowerCase()}-{ind12}-{ruchka}-{ruchka2}.jpg" />
                    {:else}
                        <img style="max-height: 250px" class="img-fluid px-3" src="/img/slaydors/открывание-{ind3.toLowerCase()}-{ind12}-{ruchka}.jpg" />
                    {/if}

                </div>

                {#if ind3 && $width*$height>0 }
                   <!-- {@const item = opening.find((el) => el.key === ind3)}-->

                    <div class="row pt-3">


                        <div class="col-12 text-center">
                            <span class="form-label text-center">
                                { stvwid.split(' мм.').join(" мм. ") }
                            </span>
                        </div>

                        <div class="col-12 text-center">
                            <span class="form-label text-center">Площадь остекления: {($width / 1000 *  $height / 1000  + (+widthGluh) * (+heightGluh) / 1000000).toFixed(2) } м.кв.</span>

                        </div>
                    </div>
                {/if}

                <div class="text-center">

                    {#if ind6!= ''}
                        <img style="max-height: 100px; min-width: 100px" class="img-fluid px-3" src="/img/slaydors/{handleImages[ind6]}" />

                    {/if}

                    {#if ind62!= '' && ind3 === 'двойное'}
                        <label class="col-12">Ручка слева</label>
                        <img style="max-height: 100px; min-width: 100px" class="img-fluid px-3" src="/img/slaydors/{handleImages[ind62]}" />
                        <label class="col-12">Ручка справа</label>
                    {/if}

                </div>
            </div>

            <div class="col-12 col-sm-7">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 10000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 3000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Количество изделий</label>
                                <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип порога</label>
                                <select class="form-control form-select" bind:value={ind7}>
                                    {#each Object.entries(porog) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ширина конструкции, мм</label>

                                <input type="number"
                                       class="form-control text-center { $width > 50000 ? 'text-danger' : '' }"
                                       step="1"
                                       min="200"
                                       max="50000"
                                       bind:value={$width}
                                       use:validate_not_empty={$width}
                                       use:validate_int={$width}>

                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Высота конструкции, мм</label>

                                <input type="number"
                                       class="form-control text-center { $height > 10000 ? 'text-danger' : '' }"
                                       step="1"
                                       min="200"
                                       max="50000"
                                       bind:value={$height}
                                       use:validate_not_empty={$height}
                                       use:validate_int={$height}>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">

                                <label class="form-label">Тип открывания (вид изнутри)</label>

                                <select class="form-control form-select" bind:value={ind3}  on:change={() => ind12 = (ind3 === 'от-центра' ? openingCentr : openingLeftRightTwin)[0]}>
                                    {#each Object.entries(openingtype) as [value, name]  }
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Количество створок</label>
                                <select class="form-control form-select" bind:value={ind12}>
                                    {#each (ind3 === 'от-центра' ? openingCentr: openingLeftRightTwin) as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>

                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет Ral</label>
                                <input type="number" class="form-control" use:validate_not_empty={ind2} bind:value={ind2} >
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип окрашивания</label>
                                <select class="form-control form-select" bind:value={ind10} >
                                    {#each color_type as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Стекло</label>
                                <select class="form-control form-select" bind:value={ind4}>
                                    {#each Object.entries(glass) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Межстекольный уплотнитель</label>
                                <select class="form-control form-select" bind:value={ind9}>
                                    {#each Object.entries(mezstekolka) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Торцевой уплотнитель</label>
                                <select class="form-control form-select" bind:value={ind13}>
                                    {#each Object.entries(torc) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-6 {(ind3 === 'от-центра' ) ? '' : 'd-none'}">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Магнитный уплотнитель</label>
                                <select class="form-control form-select" bind:value={ind14}>
                                    {#each Object.entries(magnit) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип ручки {ind3 === 'двойное' ? 'слева' : ''}</label>
                                <select class="form-control form-select" bind:value={ind6}>
                                    {#each Object.entries(handle) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 {ind3 === 'двойное' ? '' : 'd-none'}">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тип ручки справа</label>
                                <select class="form-control form-select" bind:value={ind62}>
                                    {#each Object.entries(handle) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Замок/защелка {(ind3 === 'двойное' || ind3 === 'от-центра' ) ? 'слева' : ''}</label>
                                <select class="form-control form-select" bind:value={ind8}>
                                    {#each (ind3 === 'от-центра' ?  Object.entries(zamokOtCentr) :  Object.entries(zamok))  as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 {(ind3 === 'двойное' || ind3 === 'от-центра' ) ? '' : 'd-none'}">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Замок/защелка справа</label>
                                <select class="form-control form-select" bind:value={ind82}>
                                    {#each (ind3 === 'от-центра' ?  Object.entries(zamokOtCentr) :  Object.entries(zamok)) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row pt-3">
                    <span class="d-none">Глухое остекление</span>
                    <div class="col-6 d-none">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ширина, мм</label>
                                <input type="number" class="form-control" step="10" min="250" bind:value={widthGluh}>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 d-none">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Высота, мм</label>
                                <input type="number" class="form-control" step="10" min="250" bind:value={heightGluh}>
                            </div>
                        </div>
                    </div>


                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Труба алюминиевая 100х100, мм</label>
                                <input type="number" class="form-control" bind:value={ind11}>

                            </div>
                        </div>
                    </div>

                </div>



                <div class="row">

                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Примечание</label>
                                    <textarea class="form-control" bind:value={$comment}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
